import { TFunction } from "i18next";
import * as yup from "yup";

import ParentshipTypeEnum from "./ParentshipTypeEnum";

interface Props {
  t: TFunction;
}

const ApplicantParentValidationSchema = ({ t }: Props) => {
  const requiredMsg = t("validations.required");
  const maxNumberOfCharacters = `${t("validations.maxNumberOfCharacters", {
    numberOfCharacters: 60,
  })}`;

  return yup.object().shape({
    nationalityId: yup.mixed().required(requiredMsg),
    parentshipTypeId: yup.mixed().required(requiredMsg),
    email: yup
      .string()
      .nullable()
      .email(t("validations.email"))
      .required(requiredMsg),
    phoneNumber: yup.string().nullable().required(requiredMsg),
    professionName: yup
      .string()
      .max(60, maxNumberOfCharacters)
      .nullable()
      .required(requiredMsg),
    professionalQualificationId: yup.mixed().required(requiredMsg),
    custody: yup.string().when("parentshipTypeId", {
      is: (parentshipTypeId: ParentshipTypeEnum) =>
        parentshipTypeId === ParentshipTypeEnum.Custodian,
      then: yup.string().required(requiredMsg).nullable(),
      otherwise: yup.string().nullable(),
    }),
  });
};

export default ApplicantParentValidationSchema;
